export var EmailType;
(function (EmailType) {
    EmailType["BACKEND_APP_FEEDBACK"] = "BACKEND_APP_FEEDBACK";
    EmailType["BACKEND_CALL_REMINDER"] = "BACKEND_CALL_REMINDER";
    // One branded shell for operator alerts that go to service@therame.de and to
    // nobody else (TM-9634 / #1607). Carries pre-rendered `html` like
    // BACKEND_APP_FEEDBACK does, plus the `headline` that says which watcher
    // spoke — an alert whose subject is the only clue about its origin gets
    // filed as noise.
    EmailType["BACKEND_OPERATOR_ALERT"] = "BACKEND_OPERATOR_ALERT";
    // One generic branded shell for every notification email (PRD #998). Fed by
    // the shared notification-content composer: subject/body come from the single
    // content definition, with up to two CTAs. Replaced the ~28 per-type
    // notification templates.
    EmailType["BACKEND_NOTIFICATION_GENERIC"] = "BACKEND_NOTIFICATION_GENERIC";
    // Billing Zustellung emails keep dedicated templates: they carry the document
    // as a pre-signed attachment and reference invoice/storno numbers in the body
    // (#842/#846, TM-9198), which the generic shell does not model.
    EmailType["BACKEND_NOTIFICATION_PATIENT_INVOICE_ISSUED"] = "BACKEND_NOTIFICATION_PATIENT_INVOICE_ISSUED";
    EmailType["BACKEND_NOTIFICATION_PATIENT_INVOICE_CANCELLED"] = "BACKEND_NOTIFICATION_PATIENT_INVOICE_CANCELLED";
    EmailType["BACKEND_NOTIFICATION_HONORARVEREINBARUNG_SENT"] = "BACKEND_NOTIFICATION_HONORARVEREINBARUNG_SENT";
    // One-time click-to-confirm mail for a website (embed) first-contact booking
    // (PRD #1358, RS-004). Sent to the address on the booking's intake payload —
    // the created person has a null email — so it is dispatched with an explicit
    // `to`, not resolved from a recipient user record.
    EmailType["BACKEND_EMBED_BOOKING_VERIFICATION"] = "BACKEND_EMBED_BOOKING_VERIFICATION";
    // The join mail (#1825): an office invited an address that already is an
    // Account. Office-branded, greets nobody, names no person, and links to the
    // fixed `/einladung` page without id, token or address.
    EmailType["BACKEND_JOIN_INVITE"] = "BACKEND_JOIN_INVITE";
    // The video TAN (#1855): drawn by the backend and sent to the patient's
    // Contact address only, with the `/tan-login?tan=…` link. No Account needed.
    EmailType["BACKEND_CALL_TAN"] = "BACKEND_CALL_TAN";
    EmailType["KEYCLOAK_INVITE"] = "KEYCLOAK_INVITE";
    EmailType["KEYCLOAK_CALL_INVITE"] = "KEYCLOAK_CALL_INVITE";
    EmailType["KEYCLOAK_VERIFY_MAIL"] = "KEYCLOAK_VERIFY_MAIL";
    // To an address's holder when someone registers it again (#1857). The form
    // answers like for a free address; only this mail tells. therame-branded,
    // greets nobody and names no office. `openOfficeLink` (office signup) or
    // `joinLink` (registration link) adds the way into the app.
    EmailType["KEYCLOAK_OWNER_MAIL"] = "KEYCLOAK_OWNER_MAIL";
    EmailType["KEYCLOAK_PASSWORD_RESET"] = "KEYCLOAK_PASSWORD_RESET";
})(EmailType || (EmailType = {}));
//# sourceMappingURL=email-type.js.map